import { MOKA_INVENTORY_API } from 'api/constants';

export const LIBRARY_CATEGORIES = `${MOKA_INVENTORY_API}/v2/categories`;
export const LIBRARY_CATEGORIES_V1 = `${MOKA_INVENTORY_API}/v1/categories`;
export const V1_CATEGORY_BY_ID = id =>
  `${MOKA_INVENTORY_API}/v1/categories/${id}`;
export const CATEGORY_ALL_OUTLETS = `${MOKA_INVENTORY_API}/v1/categories/create_all_outlet`;
export const ASSIGN_TO_ITEM = id =>
  `${MOKA_INVENTORY_API}/v1/categories/${id}/move_items`;
export const V1_CATEGORIES_WITH_UNCATEGORIZED = `${MOKA_INVENTORY_API}/v1/categories/with_uncategorized`;
